var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBizzerdbEmpty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 15",
    width: 15,
    height: 15,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "bizzerdb-empty-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #cccccc } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m1 0h3.2v3c1-0.6 2.2-0.9 3.3-0.9 1.3 0 2.5 0.4 3.6 1.1 1.1 0.7 1.9 1.7 2.4 2.9 0.5 1.2 0.6 2.4 0.4 3.7-0.3 1.2-0.9 2.4-1.8 3.3-0.9 0.9-2.1 1.5-3.3 1.7-1.3 0.3-2.6 0.1-3.8-0.3-1.2-0.5-2.2-1.3-2.9-2.4-0.7-1.1-1.1-2.3-1.1-3.6zm6.5 5.4c-0.6 0-1.3 0.2-1.8 0.5-0.5 0.4-1 0.9-1.2 1.5-0.2 0.5-0.3 1.2-0.2 1.8 0.1 0.6 0.4 1.2 0.9 1.7 0.5 0.4 1 0.7 1.7 0.8 0.6 0.2 1.2 0.1 1.8-0.2 0.6-0.2 1.1-0.6 1.5-1.1 0.4-0.6 0.5-1.2 0.5-1.8 0-0.9-0.3-1.7-0.9-2.3-0.6-0.6-1.4-0.9-2.3-0.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBizzerdbEmpty);
export default __webpack_public_path__ + "static/media/bizzerdb-empty.419d4367a75e868361ffc0903f62a797.svg";
export { ForwardRef as ReactComponent };